// const BASEURL="/api/"
/**
 * UAT(测试)：https://bid-uat.qibiaoduo.com/api/bid/
 *
 * Pre | Prod(预生产 | 生产)：https://api.qibiaoduo.com/api/bid/
 *
 * 开发环境：https://qbd.qike366.cn/api/bid/ 或 http://172.30.20.6:26891/api/bid/
 *
 * crm正式 https://crm.qibiaoduo.com/api/
 *
 * crm测试 http://36.112.173.234:18080/api/
 *
 *
 */
const BASEURL = 'https://api.qibiaoduo.com/api/bid/'

const BASE = 'https://crm.qibiaoduo.com/api/'

//招标
const GETBIDDING = BASEURL + 'projects/search/projects/bid'

//中标
const GETWINBID = BASEURL +  'projects/search/projects/win'

//获取手机号验证码
const  GETPHONECODE = BASEURL + 'account/security/mobile-valid-code'

//用户注册
const USERREGISTER = BASEURL + 'account/security/register'

//检验验证码是否正确
const CODECHECK = BASEURL + 'account/security/valid-code-check'

//填充访问量
const  GETVISITDATA = BASE + 'extension/promoteVisitRecord/savePromoteVisitRecord'

//填充添加推广日志
const  GETACCESSLOG = BASE + 'extension/promoteVisitLog/addVisitLog'

//中断注册
const INTERRUPT = BASE + 'extension/promoteRegistrationRecord/insertMembers'

//推送转化追踪数据
const OCPCAPILOGO = BASE + 'extension/ocpcApiLog/oCPC'

//生成关键词
const  GETKEYWORD = BASE + 'extension/promoteLink/getLinkInfoByLinkId'

//公司名称联想查询
const GETCOMPANY = BASEURL + 'publics/business/enterprises/names'

export default{
    GETBIDDING,
    GETWINBID,
    GETVISITDATA,
    GETACCESSLOG,
    GETPHONECODE,
    USERREGISTER,
    INTERRUPT,
    CODECHECK,
    OCPCAPILOGO,
    GETCOMPANY,
    GETKEYWORD
}



// WEBPACK FOOTER //
// ./src/api/index.js